import { ReactElement } from "react";
import { useTranslationWithNamespace } from "../../../hooks";

const Calendar = (): ReactElement => {
  const { t } = useTranslationWithNamespace();

  return (
    <div className="w-full bg-red-300 text-white h-56 flex justify-center items-center text-2xl">
      {t("timesheet.calendar.title")}
    </div>
  );
};

export default Calendar;
